import { success, loading, handleErrorException } from 'State/actions';
import { TitleEnum } from 'Common/Constants/Enumeration/CommonEnum';

import {
  SUBMIT_REPLACE_DEFAULT_ERROR,
  SUBMIT_REMOVE_DEFAULT_ERROR,
  FETCH_REMOVE_REPLACE_RECIPES_DEFAULT_ERROR,
} from '../../helpers/Constants';
import * as types from './types';

export const getRecipesWhereIngredientIsUsed = (ingredientId) => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(
      loading(types.REMOVE_REPLACE_INGREDIENT_GET_RECIPES_LOADING, true)
    );
    try {
      const response = await MPWWebApi.getGeneric(
        `Ingredient/GetRecipesWhereIngredientIsUsed${ingredientId}`
      );
      dispatch(
        success(types.REMOVE_REPLACE_INGREDIENT_GET_RECIPES, response.data.Data)
      );
    } catch (ex) {
      const defaultError = {
        Title: TitleEnum.Error,
        Message: FETCH_REMOVE_REPLACE_RECIPES_DEFAULT_ERROR,
      };
      dispatch(
        handleErrorException(
          ex,
          types.REMOVE_REPLACE_INGREDIENT_GET_RECIPES_ERROR,
          defaultError
        )
      );
    } finally {
      dispatch(
        loading(types.REMOVE_REPLACE_INGREDIENT_GET_RECIPES_LOADING, false)
      );
    }
  };
};

export const submitRemoveIngredient = (ingredientId, recipesIds) => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(
      loading(types.REMOVE_REPLACE_INGREDIENT_REMOVE_INGREDIENT_LOADING, true)
    );
    try {
      const response = await MPWWebApi.postGenericInsertUpdate(
        `Recipe/WriteRemoveIngredientFromRecipes`,
        { IngredientId: ingredientId, RecipeIds: recipesIds }
      );

      if (response) {
        dispatch(setSubmitSuccessful(true));
      }
    } catch (ex) {
      const defaultError = {
        Title: TitleEnum.Error,
        Message: SUBMIT_REMOVE_DEFAULT_ERROR,
      };
      dispatch(
        handleErrorException(
          ex,
          types.REMOVE_REPLACE_INGREDIENT_REMOVE_INGREDIENT_ERROR,
          defaultError
        )
      );
    } finally {
      dispatch(
        loading(
          types.REMOVE_REPLACE_INGREDIENT_REMOVE_INGREDIENT_LOADING,
          false
        )
      );
    }
  };
};

export const submitReplaceIngredient = (
  ingredientId,
  replaceIngredientId,
  recipesIds
) => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(
      loading(types.REMOVE_REPLACE_INGREDIENT_REPLACE_INGREDIENT_LOADING, true)
    );
    try {
      const response = await MPWWebApi.postGenericInsertUpdate(
        `Recipe/WriteReplaceIngredientFromRecipes`,
        {
          IngredientId: ingredientId,
          ReplacementIngredientId: replaceIngredientId,
          RecipeIds: recipesIds,
        }
      );

      if (response) {
        dispatch(setSubmitSuccessful(true));
      }
    } catch (ex) {
      const defaultError = {
        Title: TitleEnum.Error,
        Message: SUBMIT_REPLACE_DEFAULT_ERROR,
      };
      dispatch(
        handleErrorException(
          ex,
          types.REMOVE_REPLACE_INGREDIENT_REPLACE_INGREDIENT_ERROR,
          defaultError
        )
      );
    } finally {
      dispatch(
        loading(
          types.REMOVE_REPLACE_INGREDIENT_REPLACE_INGREDIENT_LOADING,
          false
        )
      );
    }
  };
};

export const setSubmitSuccessful = (isSuccess) => {
  return {
    type: types.REMOVE_REPLACE_INGREDIENT_SET_SUBMIT_SUCCESS,
    payload: isSuccess,
  };
};

export const clearErrors = () => {
  return { type: types.REMOVE_REPLACE_INGREDIENT_CLEAR_ERRORS };
};

export const clearIngredientRecipes = () => {
  return { type: types.REMOVE_REPLACE_INGREDIENT_CLEAR_RECIPES };
};



// WEBPACK FOOTER //
// ./src/pages/manageingredient/state/removereplaceingredient/actions.js